import templates from "../data/examples.json";
import { formatFrenchDate, localDateKey } from "./dates";

export const EXAMPLES = Object.entries(templates).map(([id, { label, org, doc, img }]) => ({ id, label, org, doc, img }));

// Freeze one local calendar date when the example is opened. Every surface,
// including a letter opened after midnight, uses this same analysis.deadline.
export function buildExample(id, today = new Date()) {
  const template = templates[id];
  if (!template) throw new Error("Exemple introuvable");
  const due = new Date(today.getFullYear(), today.getMonth(), today.getDate() + template.days);
  const deadline = formatFrenchDate(due);
  const analysis = JSON.parse(JSON.stringify(template.analysis).replaceAll("{deadline}", deadline));
  return {
    status: "ok", nature_document: "administratif", controle_montants: null,
    clauses_risque: [], points_negociation: [], avertissement: null,
    disclaimer: "Marianne vous aide à comprendre, mais ne remplace pas un conseil juridique.",
    ...analysis, id: `example-${id}-${localDateKey(due)}`, example_id: id, demo: true,
    reponse_precalculee: template.letter.replaceAll("{deadline}", deadline),
  };
}

export function buildExampleLetter(analysis) {
  return templates[analysis.example_id]?.letter.replaceAll("{deadline}", analysis.deadline);
}
